module.exports = __webpack_public_path__ + "img/banner2.21a3d669.jpg";